import './wydr';
import React from 'react';
import ReactDOM from 'react-dom';
import { Loader, LoaderOptions } from 'google-maps';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { unregister } from './registerServiceWorker';

import App from './App';
import { settings } from './settings';
import analyticsWrapper from './utils/analyticsWrapper';
import 'flatpickr/dist/themes/dark.css';
import './styles/index.scss';
import { ThemeProvider } from '@material-ui/core/styles';
import pbMaterialTheme from './styles/materialThemeProvider';
import { datadogLogs } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';

if (settings.sentryDSN) {
  Sentry.init({
    dsn: settings.sentryDSN,
    integrations: [new Integrations.BrowserTracing()],
    environment: settings.sentryEnvironment,
    release: settings.sentryRelease,

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
  });
}

if (settings.datadog) {
  datadogLogs.init({
    clientToken: settings.datadog.logs.token,
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sampleRate: 100,
    env: settings.datadog.env,
    service: settings.datadog.service,
  });
  if (settings.datadog.rum) {
    datadogRum.init({
      applicationId: settings.datadog.rum.applicationId,
      clientToken: settings.datadog.rum.clientToken,
      site: 'datadoghq.eu',
      service: settings.datadog.service,
      env: settings.datadog.env,
      sampleRate: 100,
      trackInteractions: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    datadogRum.startSessionReplayRecording();
  }
}

const overrideFaviconIfEnvMatches = (environment: string, iconUrl: string) => {
  if (settings.environment === environment) {
    const favicon = document.getElementById('favicon');
    favicon && ((favicon as any).href = iconUrl);
  }
};
overrideFaviconIfEnvMatches('development', '/favicon-local.png');
overrideFaviconIfEnvMatches('test', '/favicon-test.png');

try {
  // react ga will use the existing script
  analyticsWrapper.initialize();
  const options: LoaderOptions = { libraries: ['places', 'geometry'] };
  const loader = new Loader(settings.googleMapsApiKey, options);

  loader.load().then(() => {
    ReactDOM.render(
      <ThemeProvider theme={pbMaterialTheme}>
        <App />
      </ThemeProvider>,
      document.getElementById('root')
    );
  });
} catch (err) {
  Sentry.captureException(err);
  throw err;
}

unregister();
